import { SPARKL } from '../../consts/constants';
import { HALE_PRIVACY_URL, HALE_TERMS_URL } from './hale.config';
import { getActiveBrandKey } from './resolveBrand';
import { BrandKey } from './types';

export { HALE_PRIVACY_URL, HALE_TERMS_URL };

export interface BrandLegalUrls {
  termsUrl: string;
  privacyUrl: string;
}

export const getBrandLegalUrls = (
  brandKey?: BrandKey | null,
): BrandLegalUrls => {
  const key = brandKey ?? getActiveBrandKey();

  if (key === 'hale') {
    return {
      termsUrl: HALE_TERMS_URL,
      privacyUrl: HALE_PRIVACY_URL,
    };
  }

  return {
    termsUrl:
      process.env.REACT_APP_TERMS_AND_CONDITIONS_URL ||
      SPARKL.termsAndConditions,
    privacyUrl:
      process.env.REACT_APP_PRIVACY_POLICY_URL || SPARKL.privacyPolicy,
  };
};
